module.exports = __webpack_public_path__ + "static/1-d9f5c9e70bd1dd173beb2c2bac9ef2af.jpg";